import { useQuery, useQueryClient } from "@tanstack/react-query"
import { useCallback } from "react"
import { MacAddressGet } from "../app/models/SupplierPortal"
import { digitalManagerApi } from "../services/api"

export function useMacAddresses() {
  const queryClient = useQueryClient()

  const { data: macAddressList = [], isLoading: isLoadingMacAddress } = useQuery({
    queryKey: ["macAddresses"],
    queryFn: () =>
      digitalManagerApi
        .get<MacAddressGet[]>(`/litePanelPro/macAddresses`)
        .then((r) => r.data),
  })

  const reloadMacAddresses = useCallback(
    () => queryClient.invalidateQueries({ queryKey: ["macAddresses"] }),
    [queryClient]
  )

  return {
    macAddressList,
    reloadMacAddresses,
    isLoadingMacAddress,
  }
}
